/* Fiix Buy / Rent toggle — switches the product column in place (2026-10-29 mock-up for Tim).
   Replaces the 2025 version that navigated to the other product page.
   How it works: snippets/fiix-buy-rent.liquid renders two radio cards on both PDPs (fiix-tennis-elbow = buy,
   fiix-elbow-rental = rent). On change we prefetch the other product's page, swap <product-info> (the whole right
   column: title, price, toggle, why-buy/why-rent, form, tabs) plus the sticky bar. The URL never changes (chris,
   10/29) and the gallery stays (same media on both products).
   Rent mode after a swap: the Product Rentals Pro app block arrives as raw un-initialised widget markup, so it is
   replaced by our own theme-styled Add to cart, which posts the widget's exact line shape (deposit with selling
   plan + rental), the same as the one-page landing chooser.
   A native rental page load (PRP initialised) is left to the widget. If the prefetch fails we fall back to navigating. */
(function () {
  'use strict';
  var T = window.theme || {};
  var routes = T.routes || {};
  var CART_URL = routes.cart_url || '/cart';
  var ADD_URL = routes.cart_add_url || '/cart/add';
  var INFO = 'product-info';
  var STICKY = 'product-sticky-form';
  var cache = {};

  function box() { return document.querySelector('[data-fiix-br]'); }
  function mode() { var b = box(); return b ? b.getAttribute('data-mode') : null; }
  function urlFor(m) { var b = box(); return b ? b.getAttribute('data-' + m + '-url') : null; }

  /* ---------- fetch + swap ---------- */
  function snapshot(doc, m) {
    var info = doc.querySelector(INFO);
    if (!info) return null;
    var st = doc.querySelector(STICKY);
    cache[m] = { info: info.outerHTML, sticky: st ? st.outerHTML : '' };
    return cache[m];
  }
  function prefetch(m) {
    if (cache[m]) return Promise.resolve(cache[m]);
    var u = urlFor(m);
    if (!u) return Promise.reject(new Error('no url for ' + m));
    return fetch(u, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var s = snapshot(doc, m);
        if (!s) throw new Error('no product-info in ' + u);
        return s;
      });
  }
  function replaceEl(sel, html) {
    var old = document.querySelector(sel);
    if (!old || !html) return null;
    var tpl = document.createElement('template');
    tpl.innerHTML = html.trim();
    var el = tpl.content.firstElementChild;
    if (!el) return null;
    old.replaceWith(el);
    return el;
  }
  /* inline scripts inserted via innerHTML never run; re-run the plain ones (e.g. the free-bundle size select) */
  function runScripts(root) {
    root.querySelectorAll('script:not([src])').forEach(function (s) {
      var t = (s.type || '').toLowerCase();
      if (t && t !== 'text/javascript' && t !== 'module') return;
      var n = document.createElement('script');
      if (t) n.type = t;
      n.textContent = s.textContent;
      try { s.replaceWith(n); } catch (e) { console.error(e); }
    });
  }
  function swapTo(m) {
    var cur = mode();
    if (!cur || cur === m) return;
    /* prefer the server copy of the current column (already-upgraded markup like <split-words> re-splits badly);
       the live DOM is only the fallback while that prefetch is still in flight */
    var b = box();
    b.setAttribute('data-busy', '');
    var keepCurrent = cache[cur] ? Promise.resolve() : prefetch(cur).catch(function () { snapshot(document, cur); });
    Promise.all([prefetch(m), keepCurrent]).then(function (res) {
      var s = res[0];
      var info = replaceEl(INFO, s.info);
      if (s.sticky) replaceEl(STICKY, s.sticky);
      /* the URL never changes: the visitor stays on the page they opened (chris, 10/29) */
      if (m === 'rent') installRentForm();
      if (info) runScripts(info);
      bind();
      document.dispatchEvent(new CustomEvent('fiix:mode', { detail: { mode: m } }));
    }).catch(function (e) {
      console.error('[fiix-toggle] swap failed, navigating instead', e);
      window.location.assign(urlFor(m));
    });
  }

  /* ---------- cart helpers (theme drawer handoff; same as the one-page landing) ---------- */
  function bundledSections() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    return sections;
  }
  function getCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function openDrawer(trigger, cart, sections, variantId) {
    if (sections) cart.sections = sections;
    try {
      if (T.pubsub && T.pubsub.PUB_SUB_EVENTS) {
        T.pubsub.publish(T.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId, cart: cart });
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      }
    } catch (e) { console.error(e); }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') drawer.show(trigger);
    else window.location.href = CART_URL;
  }
  function addItems(items, trigger) {
    var sections = bundledSections();
    return fetch(ADD_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message || 'Could not add to cart.');
        return getCart().then(function (cart) {
          openDrawer(trigger, cart, state.sections, items[items.length - 1].id);
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: state } }));
          return cart;
        });
      });
  }

  /* ---------- rent add-to-cart after a swap ---------- */
  function rentItems() {
    var b = box();
    /* Shopify lists the newest line first, so the deposit goes in first and the device shows on top. One rental per order. */
    return [
      { id: Number(b.getAttribute('data-deposit-variant')), quantity: 1, selling_plan: Number(b.getAttribute('data-deposit-plan')), properties: { _prp_id: Date.now() + '_1', _prp_deposit: '1' } },
      { id: Number(b.getAttribute('data-rent-variant')), quantity: 1, properties: { _has_deposit: 2 } }
    ];
  }
  /* The Product Rentals Pro app block arrives as raw, un-initialised widget markup (duration pickers, calendar,
     "..." button). Replace the whole block with a theme-styled Add to cart form of our own. */
  function installRentForm() {
    if (document.querySelector(INFO + ' [data-fiix-rent-form]')) return;
    var widget = document.querySelector(INFO + ' .rw-container');
    var block = widget ? (widget.closest('.shopify-app-block') || widget) : null;
    var wrap = document.createElement('div');
    wrap.className = 'product-form-wrapper';
    wrap.innerHTML =
      '<form class="product-form grid gap-8" data-fiix-rent-form novalidate>' +
        '<div class="product-form__buttons grid gap-4">' +
          '<div class="product-form__error-message alert alert--error text-sm font-medium leading-tight" role="alert" hidden></div>' +
          '<div class="buy-buttons grid gap-4">' +
            '<button type="submit" class="product-form__submit button button--primary button--fixed grow" is="hover-button">' +
              '<span class="btn-fill" data-fill></span><span class="btn-text"><span>Add to cart</span></span>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</form>';
    if (block) block.replaceWith(wrap);
    else { var anchor = document.querySelector(INFO + ' .rte') || box(); anchor.insertAdjacentElement('afterend', wrap); }
    var form = wrap.querySelector('form');
    var btn = form.querySelector('[type="submit"]');
    var errEl = form.querySelector('.product-form__error-message');
    var locked = false;
    function submitRent() {
      if (locked) return;
      locked = true;
      if (btn) btn.setAttribute('aria-busy', 'true');
      var err = errEl || box().querySelector('.fiix-br__err');
      if (err) err.hidden = true;
      var rid = Number(box().getAttribute('data-rent-variant'));
      getCart().then(function (cart) {
        var already = (cart.items || []).some(function (i) { return i.variant_id === rid; });
        if (already) { openDrawer(btn, cart, null, rid); return cart; }
        return addItems(rentItems(), btn);
      }).catch(function (e) {
        console.error(e);
        if (err) { err.textContent = (e && e.message) || 'Something went wrong. Please try again.'; err.hidden = false; }
      }).then(function () { locked = false; if (btn) btn.removeAttribute('aria-busy'); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); submitRent(); }, true);
    /* the sticky bar's button targets a theme form id the rental column does not have — route it here */
    var sb = document.querySelector(STICKY + ' [type="submit"]');
    if (sb && !sb.hasAttribute('data-fiix-bound')) {
      sb.setAttribute('data-fiix-bound', '');
      sb.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); submitRent(); }, true);
    }
  }

  /* ---------- wiring ---------- */
  function bind() {
    var b = box();
    if (!b || b.hasAttribute('data-fiix-bound')) return;
    b.setAttribute('data-fiix-bound', '');
    b.querySelectorAll('input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) swapTo(r.value); });
    });
    var cur = mode(), other = cur === 'buy' ? 'rent' : 'buy';
    var idle = window.requestIdleCallback || function (f) { setTimeout(f, 250); };
    idle(function () {
      prefetch(other).catch(function () {});
      if (!cache[cur]) prefetch(cur).catch(function () {});
    });
  }
  function init() {
    bind();
    var b = box();
    if (b && mode() === 'buy' && (location.hash === '#rent' || location.hash === '#deposit-option-label')) {
      var r = b.querySelector('input[value="rent"]');
      if (r) { r.checked = true; swapTo('rent'); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
